import { render } from "./filesSelect.vue?vue&type=template&id=6703d7a7&scoped=true"
import script from "./filesSelect.vue?vue&type=script&lang=js"
export * from "./filesSelect.vue?vue&type=script&lang=js"

import "./filesSelect.vue?vue&type=style&index=0&id=6703d7a7&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6703d7a7"]])

export default __exports__